/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles
 */

import Bold from './bold';
import BoldEditing from './bold/boldediting';
import BoldUI from './bold/boldui';
import Code from './code';
import CodeEditing from './code/codeediting';
import CodeUI from './code/codeui';
import Italic from './italic';
import ItalicEditing from './italic/italicediting';
import ItalicUI from './italic/italicui';
import Strikethrough from './strikethrough';
import StrikethroughEditing from './strikethrough/strikethroughediting';
import StrikethroughUI from './strikethrough/strikethroughui';
import Subscript from './subscript';
import SubscriptEditing from './subscript/subscriptediting';
import SubscriptUI from './subscript/subscriptui';
import Superscript from './superscript';
import SuperscriptEditing from './superscript/superscriptediting';
import SuperscriptUI from './superscript/superscriptui';
import Underline from './underline';
import UnderlineEditing from './underline/underlineediting';
import UnderlineUI from './underline/underlineui';

export default {
	Bold,
	BoldEditing,
	BoldUI,
	Code,
	CodeEditing,
	CodeUI,
	Italic,
	ItalicEditing,
	ItalicUI,
	Strikethrough,
	StrikethroughEditing,
	StrikethroughUI,
	Subscript,
	SubscriptEditing,
	SubscriptUI,
	Superscript,
	SuperscriptEditing,
	SuperscriptUI,
	Underline,
	UnderlineEditing,
	UnderlineUI
};
